import { createFileRoute } from "@tanstack/react-router";
import { requireAdmin } from "../lib/auth-guards";
import { UserManagementPageContainer } from "@charphq/ui/components/user-management/user-management-page-container";

export const Route = createFileRoute("/users")({
  beforeLoad: async () => {
    // Platform-wide user administration (create users, grant super-admin, ban, delete)
    // is a super-admin / global-admin surface. Org owners/admins manage their own people
    // via /organizations → Manage Members. Backend RBAC still enforces every action.
    await requireAdmin();
  },
  component: UsersPageComponent,
});

function UsersPageComponent() {
  return (
    <UserManagementPageContainer
      route={Route}
      breadcrumbs={[{ label: "Home", href: "/" }, { label: "User Management" }]}
    />
  );
}
